import { useEffect, useState } from "react"
import { Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"

const DARK_THEME = "dark"
const LIGHT_THEME = "light"
const DEFAULT_THEME = LIGHT_THEME

export const useTheme = () => {
  const [theme, setTheme] = useState<string>(() => {
    if (typeof window !== "undefined") {
      const localStorageTheme = localStorage.getItem("theme")
      if (
        localStorageTheme === null ||
        localStorageTheme === "null" ||
        localStorageTheme === undefined
      ) {
        return DEFAULT_THEME
      }
      return localStorageTheme
    }
    return DEFAULT_THEME
  })

  const switchDarkMode = () => {
    if (theme === DARK_THEME) {
      setTheme(LIGHT_THEME)
    }
    if (theme === LIGHT_THEME) {
      setTheme(DARK_THEME)
    }
  }

  useEffect(() => {
    localStorage.setItem("theme", theme)
    const root = document.documentElement
    if (theme === DARK_THEME) {
      root.classList.add("dark")
    } else {
      root.classList.remove("dark")
    }
  }, [theme])

  return { value: theme, switchDarkMode, isDark: theme === DARK_THEME }
}

export const ThemeSwitch = () => {
  const theme = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <Button variant="ghost" size="icon" className="w-10 h-10" />
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => theme.switchDarkMode()}
      className="w-10 h-10"
    >
      {theme.isDark ? (
        <Sun className="h-6 w-6" />
      ) : (
        <Moon className="h-6 w-6" />
      )}
      <span className="sr-only">Toggle theme</span>
    </Button>
  )
}
